export const COVER_PAGE_ONLY_TOGGLE = 'COVER_PAGE_ONLY_TOGGLE';
export const SET_NUMBER = 'SET_NUMBER';
export const SET_ERROR = 'SET_ERROR';
export const SET_TYPE = 'SET_TYPE';
export const SET_PARENT_PETITION_ID = 'SET_GENERATE_PARENT_PETITION_ID';
export const TOGGLE_GENERATE_CSV = 'TOGGLE_GENERATE_CSV';

export const GENERATE_PETITION_REQUEST = 'GENERATE_PETITION_REQUEST';
export const GENERATE_PETITION_SUCCESS = 'GENERATE_PETITION_SUCCESS';
export const GENERATE_PETITION_FAILED = 'GENERATE_PETITION_FAILED';

export const FETCH_PARENT_PETITIONS_REQUEST = 'FETCH_GENERATE_PARENT_PETITIONS_REQUEST';
export const FETCH_PARENT_PETITIONS_SUCCESS = 'FETCH_GENERATE_PARENT_PETITIONS_SUCCESS';
export const FETCH_PARENT_PETITIONS_FAILED = 'FETCH_GENERATE_PARENT_PETITIONS_FAILED';
